export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  COLLABORATEURS_OAC = 'ROLE_COLLABORATEURS-OAC',
  COLLABORATEURS_OU = 'ROLE_COLLABORATEURS-OU',
  COLLABORATEURS_DT = 'ROLE_COLLABORATEURS-DT',
  COLLABORATEURS_OCLPF = 'ROLE_COLLABORATEURS-OCLPF',
  ACCES_GED = 'ROLE_F-ACCES-GED'
}
